// DealLostReasonDialog — обязательный выбор причины перед POST сделки в LOST (V16 W3).

import { ReasonSelectDialog } from '@/components/ReasonSelectDialog';
import { t } from '@/i18n';

/** Пропсы диалога причины отказа при переходе сделки в LOST. */
export interface DealLostReasonDialogProps {
  /** Открыт ли диалог. */
  open: boolean;
  /** Закрытие без POST (отмена). */
  onClose: () => void;
  /** Подтверждение: выбранный id причины; POST делает владелец (DealDetailPage). */
  onConfirm: (rejectionReasonId: string) => void;
  /** Мутация стадии в полёте — блокирует повторный submit. */
  pending?: boolean;
}

/**
 * Диалог выбора причины отказа перед переводом сделки в LOST.
 * Каталог — GET /api/rejection-reasons; без OK POST не уходит.
 */
export function DealLostReasonDialog(props: DealLostReasonDialogProps): JSX.Element {
  return (
    <ReasonSelectDialog
      {...props}
      titleId="deal-lost-reason-title"
      title={t('crm.deals.lostReason.title')}
      label={t('crm.deals.lostReason.label')}
      confirmLabel={t('crm.deals.lostReason.confirm')}
      loadError={t('crm.deals.lostReason.loadError')}
      cancelLabel={t('common.cancel')}
    />
  );
}
